const BUG_PROMPT = "Did you experience a bug or something unexpected?";
const BUG_TEXT_PROMPT = "What happened?";
const FREEFORM_PROMPT = "Anything else we should know?";
export const POST_ONBOARDING_SURVEY = {
    id: "post_onboarding_sentiment",
    trigger: "modal",
    title: "Post-onboarding",
    questionSet: "Onboarding sentiment",
    surfaceLabel: "post-onboarding experience",
    ratingPrompt: "How would you rate onboarding overall?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    questions: [
        {
            id: "clarity",
            prompt: "After onboarding, how clear are you on what HealthOS is for? Is anything unclear?",
        },
        {
            id: "expectations",
            prompt: "Did the onboarding experience match with what you expected from the demo?",
        },
        {
            id: "surprise",
            prompt: "What surprised you about the onboarding experience?",
        },
        {
            id: "missing",
            prompt: "What was missing, if anything, from the onboarding experience?",
        },
    ],
};
export const TODAY_SURVEY = {
    id: "today_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Today page",
    surfaceLabel: "Today page",
    ratingPrompt: "How would you rate the Today page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/", "/today"],
    questions: [
        {
            // The id predates the weekly cadence; answers are stored under it, so it stays.
            id: "daily_brief",
            prompt: "What did you think of the Weekly Brief?",
        },
        {
            id: "works",
            prompt: "What works well on the Today page?",
        },
        {
            id: "does_not_work",
            prompt: "What feels unclear, noisy, missing, or not useful on the Today page?",
        },
    ],
};
export const PLAN_SURVEY = {
    id: "plan_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Plan page",
    surfaceLabel: "Plan page",
    ratingPrompt: "How would you rate the Plan page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/plan"],
    questions: [
        {
            id: "works",
            prompt: "What works well when reviewing or changing your plan?",
        },
        {
            id: "microsteps",
            prompt: "Do the microsteps feel clear, realistic, and worth doing?",
        },
        {
            id: "goals",
            prompt: "Do the goals on the plan match what you are trying to improve?",
        },
        {
            id: "plan_usefulness",
            prompt: "What would make the plan or microsteps more useful?",
        },
        {
            id: "does_not_work",
            prompt: "What does not work, or what would you change about the Plan page?",
        },
    ],
};
export const SNAPSHOT_SURVEY = {
    id: "snapshot_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Snapshot page",
    surfaceLabel: "Snapshot page",
    ratingPrompt: "How would you rate the Snapshot page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/score"],
    questions: [
        {
            id: "new_information",
            prompt: "Does this view tell you something you didn't already know?",
        },
        {
            id: "expectations",
            prompt: "What do you expect or hope to see here?",
        },
        {
            id: "works",
            prompt: "What works well when reading your Snapshot?",
        },
        {
            id: "does_not_work",
            prompt: "What is confusing, missing, or not believable on the Snapshot page?",
        },
    ],
};
export const LIBRARY_SURVEY = {
    id: "library_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Library page",
    surfaceLabel: "Library page",
    ratingPrompt: "How would you rate the Library page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/library"],
    questions: [
        {
            id: "overall",
            prompt: "What do you think of the Library page?",
        },
        {
            id: "works",
            prompt: "What works well when finding or saving content?",
        },
        {
            id: "does_not_work",
            prompt: "What does not work, or what would you change?",
        },
    ],
};
export const CONNECTIONS_SURVEY = {
    id: "connections_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Connectors page",
    surfaceLabel: "Connectors page",
    ratingPrompt: "How would you rate the Connectors page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/connectors"],
    questions: [
        {
            id: "works",
            prompt: "What works well when connecting or reviewing data sources?",
        },
        {
            id: "does_not_work",
            prompt: "What is confusing, missing, or not working on the Connectors page?",
        },
    ],
};
export const SETTINGS_SURVEY = {
    id: "settings_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "Settings page",
    surfaceLabel: "Settings page",
    ratingPrompt: "How would you rate the Settings page?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    routePrefixes: ["/settings"],
    questions: [
        {
            id: "works",
            prompt: "What works well when reviewing settings?",
        },
        {
            id: "does_not_work",
            prompt: "What is confusing, missing, or not working on the Settings page?",
        },
    ],
};
export const GENERAL_APP_SURVEY = {
    id: "general_feedback",
    trigger: "modal",
    title: "Feedback",
    questionSet: "HealthOS",
    surfaceLabel: "HealthOS",
    ratingPrompt: "How would you rate this part of HealthOS?",
    freeformPrompt: FREEFORM_PROMPT,
    bugPrompt: BUG_PROMPT,
    bugTextPrompt: BUG_TEXT_PROMPT,
    questions: [
        {
            id: "works",
            prompt: "What works well here?",
        },
        {
            id: "does_not_work",
            prompt: "What does not work, or what would you change?",
        },
    ],
};
export const HEALTHOS_SURVEYS = [
    POST_ONBOARDING_SURVEY,
    TODAY_SURVEY,
    PLAN_SURVEY,
    SNAPSHOT_SURVEY,
    LIBRARY_SURVEY,
    CONNECTIONS_SURVEY,
    SETTINGS_SURVEY,
    GENERAL_APP_SURVEY,
];
const ROUTE_SURVEYS = [
    PLAN_SURVEY,
    SNAPSHOT_SURVEY,
    LIBRARY_SURVEY,
    CONNECTIONS_SURVEY,
    SETTINGS_SURVEY,
    TODAY_SURVEY,
];
export function getHealthOsSurvey(id) {
    return HEALTHOS_SURVEYS.find((survey) => survey.id === id) ?? null;
}
export function getHealthOsSurveyForRoute(route) {
    const path = normaliseRoute(route);
    return (ROUTE_SURVEYS.find((survey) => survey.routePrefixes?.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) ?? GENERAL_APP_SURVEY);
}
function normaliseRoute(route) {
    const path = route.split(/[?#]/)[0] ?? "/";
    return path.length > 0 ? path : "/";
}
//# sourceMappingURL=survey.js.map